import React from "react"
import { StyledTable, StyledTableContainer } from "./partials"

export interface TableProps {
  table: Array
  vertical_headings: boolean
}

export const TableCmp: React.FC<TableProps> = ({ table, vertical_headings }) => (
  <StyledTableContainer>  
    <StyledTable vertical_headings={vertical_headings}>
      {table.thead && table.thead.length > 0 && (
        <thead>
          <tr>
            {table.thead.map((head: any) => (
              <th>{head.value}</th>
            ))}
          </tr>
        </thead>
      )}
      {table.tbody && table.tbody.length > 0 && (
        <tbody>
          {table.tbody.map((row: any) => (
            <tr>
              {row.body.map((data: any) => (
                <td>{data.value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
    </StyledTable>
  </StyledTableContainer>
)
